/**
 * Quote Request – "Demander un devis"
 *
 * Flow:
 *  1. Guest → redirect to Shopify new customer accounts login
 *  2. Logged-in → POST cart JSON to Cloudflare Worker (CORS proxy)
 *     → Worker forwards to Make.com webhook → draft order created
 *     → clear cart → redirect to confirmation page
 */

const QUOTE_LOGIN_URL = 'https://shopify.com/98755051902/account';
const QUOTE_CONFIRMATION_URL = 'https://www.neofermeture.com/pages/confirmation-de-demande-de-devis';

function initQuoteRequest() {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-quote-request-btn');
    if (!btn) return;
    e.preventDefault();
    handleQuoteRequest(btn);
  });
}

async function handleQuoteRequest(btn) {
  const isLoggedIn = btn.dataset.customerLoggedIn === 'true';

  if (!isLoggedIn) {
    window.location.href = QUOTE_LOGIN_URL;
    return;
  }

  const workerUrl = btn.dataset.webhookUrl;
  if (!workerUrl) {
    console.error('[QuoteRequest] No Worker URL configured in theme settings.');
    return;
  }

  btn.disabled = true;
  btn.classList.add('loading');
  const originalText = btn.innerHTML;
  btn.innerHTML = '<span class="quote-request-spinner"></span> Envoi en cours…';

  try {
    const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });

    if (cart.items.length === 0) {
      btn.disabled = false;
      btn.classList.remove('loading');
      btn.innerHTML = originalText;
      return;
    }

    var payload = {
      customer: {
        id: btn.dataset.customerId ? parseInt(btn.dataset.customerId) : null,
        email: btn.dataset.customerEmail || '',
        first_name: btn.dataset.customerFirstName || '',
        last_name: btn.dataset.customerLastName || ''
      },
      line_items: cart.items.map(function (item) {
        return {
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          title: item.title,
          variant_title: item.variant_title,
          sku: item.sku || '',
          price: (item.price / 100).toFixed(2),
          properties: item.properties
        };
      }),
      note: cart.note || '',
      total_price: (cart.total_price / 100).toFixed(2),
      currency: cart.currency
    };

    var response = await fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Worker returned ' + response.status);
    }

    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    window.location.href = QUOTE_CONFIRMATION_URL;

  } catch (err) {
    console.error('[QuoteRequest]', err);
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.innerHTML = originalText;
    alert('Une erreur est survenue lors de la demande de devis. Veuillez réessayer.');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuoteRequest);
} else {
  initQuoteRequest();
}
